var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.0909,
    height: 20,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9285 14.7647L10.3452 3.51466C10.2048 3.16544 9.86969 2.93781 9.50016 2.93781C9.13063 2.93781 8.79547 3.16544 8.65511 3.51466L4.07177 14.7647C3.87707 15.2425 4.09773 15.7915 4.56505 15.9904C5.03427 16.1905 5.56995 15.9634 5.76359 15.4859L6.67453 13.2503H12.3264L13.2373 15.4859C13.3836 15.8457 13.7248 16.0631 14.0838 16.0631C14.2011 16.0631 14.3206 16.0398 14.4361 15.9903C14.9028 15.7901 15.1233 15.2422 14.9285 14.7647ZM7.41188 11.375L9.50016 6.31251L11.5627 11.375H7.41188Z",
    fill: "#495376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordA);
export default __webpack_public_path__ + "static/media/word_a.5fe9d9b443611573dd47430a72425d65.svg";
export { ForwardRef as ReactComponent };